<template>
    <svg class="fill-current overflow-hidden">
        <use :xlink:href="`#${iconName}`" />
    </svg>
</template>

<script>

export default {
    name: 'SvgIcon',
    props: {
        iconName: {
            type: String,
            required: true
        },
    },
};
</script>

<style scoped>
svg {
    width: 1rem;
    height: 1rem;
}
</style>
